module.exports = __webpack_public_path__ + "img/ms.d0bb886c.svg";